import React, {useEffect} from "react";
import {EstimateType} from "@estimate/types/estimate.types";
import {Maybe} from "@src/types/global.types";
import {useParams} from "react-router-dom";
import {EstimateCardComponent, EstimateItemEdiUploadModal} from "@estimate/components";
import {Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@src/store";
import {fetchEstimate as fetchEstimateState, estimateState, clearEstimate} from "@estimate/store/estimateSlice";

interface EstimateCardProps{

}

const EstimateCardView: React.FC<EstimateCardProps> = () => {
    const {id: estimateId} = useParams();
    const estimate: Maybe<EstimateType> = useSelector(estimateState).estimate;
    const dispatch = useDispatch<AppDispatch>();

    const fetchEstimate = (): void => {
        dispatch(fetchEstimateState(estimateId))
    }

    useEffect(() => {
        fetchEstimate();
        return () => { dispatch(clearEstimate())}
    }, [estimateId]);

    if (!estimate) {
        return null;
    }

    return (
        <div className="view-estimate-card">
            <div className="page-header">
                <Row className="row g-2 align-items-center">
                    <Col className="col">
                        <div className="page-pretitle">
                            Kosztorys
                        </div>
                        <h2 className="page-title">
                            {estimate.name}
                        </h2>
                    </Col>
                </Row>
            </div>

            <div className="page-body">
                <EstimateCardComponent fetchEstimate={fetchEstimate} />
                <EstimateItemEdiUploadModal />


            </div>
        </div>
    )
}

export default EstimateCardView;